import { render, staticRenderFns } from "./mains.vue?vue&type=template&id=28dae436&scoped=true"
import script from "./mains.vue?vue&type=script&lang=js"
export * from "./mains.vue?vue&type=script&lang=js"
import style0 from "./mains.vue?vue&type=style&index=0&id=28dae436&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28dae436",
  null
  
)

export default component.exports